import React from 'react';

import { Content } from './Content.js';
import NrgComponent from './../NrgComponent.jsx';

export default class CompanyHistoryPanel extends NrgComponent {

  render() {
    return (
      <div className="CompanyHistoryPanel row">
        <div className="col-xs-16">
          <div className="fake-void left"></div>
          <div className="fake-void right"></div>
          <div className="fake-void extra"></div>
          <header>
            <span>{Content[this.props.page].title}</span>
          </header>
          <div className="body" data-scroll-item-once>{Content[this.props.page].body}</div>
          <div className="image-container" data-scroll-item-once>
            <div className="image">
              <img src={Content[this.props.page].image} alt={Content[this.props.page].title}/>
            </div>
            <div className="year">{Content[this.props.page].year}</div>
          </div>
          <footer data-scroll-item-once>
            <span>{Content[this.props.page].footer}</span>
          </footer>
        </div>
      </div>
    );
  }

};
